import {
  createSlice,
  isFulfilled,
  isPending,
  isRejected,
} from "@reduxjs/toolkit";
import {
  clearAppSession,
  clearAppError,
} from "../../common/redux/globalActions";
import type { Sitter, ErrorsFromBackendType } from "../ts";
import {
  GetOnboardSingpassThunk,
  GetSingpassAuthUrlThunk,
  OnboardVerificationThunk,
} from "./thunk";

const initialState: Sitter = {
  error: null,
  singpass_verification: null
};

export const sitterSlice = createSlice({
  name: "sitter",
  initialState: initialState,
  reducers: {
    clearState: (state) => {
      state.error = initialState.error;
    },
  },
  extraReducers: (builder) => {
    builder
      // Global Actions
      .addCase(clearAppSession, () => initialState)
      .addCase(clearAppError, (state, action) => {
        if (action.payload && state.error && action.payload in state.error) {
          delete state.error[action.payload];
        } else {
          state.error = null;
        }
      })
      // Feature Actions
      .addMatcher(isFulfilled(GetSingpassAuthUrlThunk), (state) => {
        state.error = null;
      })
        .addMatcher(isFulfilled(GetOnboardSingpassThunk), (state, action) => {
        state.singpass_verification = action.payload;
      })
      .addMatcher(
        isPending(
          GetSingpassAuthUrlThunk,
          GetOnboardSingpassThunk,
          OnboardVerificationThunk,
        ),
        (state) => {
          state.error = null;
        },
      )
      .addMatcher(
        isRejected(
          GetSingpassAuthUrlThunk,
          GetOnboardSingpassThunk,
          OnboardVerificationThunk,
        ),
        (state, action) => {
          state.error = action.payload as ErrorsFromBackendType;
        },
      );
  },
});

export const sitterActions = sitterSlice.actions;

export const { reducer: sitterReducer } = sitterSlice;

export default sitterReducer;
